import { APP_LOCAL_STORAGE_BUILD_VERSION_KEY } from "../config";

export const preventDefault = (e) => e.preventDefault();
export const preventDefaultWithCallback = (func) => (e) => {
  e.preventDefault();
  func();
};

export const formatString = (value, defaultReturn = "") => {
  return value || defaultReturn;
};

export const reduceStringLength = (value, size = 45) => {
  return value.length >= size ? `${value.substr(0, size)}...` : value;
};

export const formatURL = (link) => {
  const pattern = /^((http|https|ftp):\/\/)/;
  if (!pattern.test(link)) {
    link = `http://${link}`;
  }
  return link;
};

export const clearTablesFiltersLocalStorage = () => {
  try {
    const envBuildVersion = process.env.REACT_APP_BUILD_VERSION;
    const localStorageSavedBuildVersion = localStorage.getItem(APP_LOCAL_STORAGE_BUILD_VERSION_KEY);
    const envBuildVersionToString = envBuildVersion ? envBuildVersion.toString() : "";

    if (envBuildVersionToString && envBuildVersionToString !== localStorageSavedBuildVersion) {
      localStorage.setItem(APP_LOCAL_STORAGE_BUILD_VERSION_KEY, envBuildVersion);
      Object.keys(localStorage || {}).forEach((key) => {
        const keyLowerCase = key ? key.toLowerCase() : "";
        if (keyLowerCase?.includes("table")) {
          localStorage.removeItem(key);
        }
      });
    }
  } catch (err) {
    console.warn("LocalStorage unavailable, clearTablesFiltersLocalStorage skipped:", err);
  }
};

export const formatPhoneNumber = (value) => {
  return value ? value.toString().replace(/([^+0-9 ]+)/, "") : value;
};

export const hexToRgba = (hex, alpha) => {
  const sanitized = (hex || "").replace("#", "");
  if (sanitized.length !== 6) return hex;
  const r = Number.parseInt(sanitized.substring(0, 2), 16);
  const g = Number.parseInt(sanitized.substring(2, 4), 16);
  const b = Number.parseInt(sanitized.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export const getUserTitleTranslation = (title, trans) => {
  if (title === "Mr") {
    return trans("container.general_words.mr_select");
  } else if (title === "Mr./Mrs.") {
    return trans("container.general_words.mr_mrs_select");
  }
  return trans("container.general_words.ms_select");
};

export const getActiveFilterOptions = (trans) => [
  { value: "1", name: trans("container.general_words.active") },
  { value: "0", name: trans("container.general_words.inactive") }
];
